export const HOMETITLE = 'hometitle';
